import testImageSrc from './__tests__/test-image.png';

export default testImageSrc;
